import {environment} from '@/commons/configs/Config';
import Cookies from "js-cookie";

export async function getToken(tokenValue) {
    const result = fetch(environment.apiUrlOne + '/token/getToken/' + tokenValue, {
        method: 'GET'
    })
    return await result;
}

export async function sendVerifyEmail() {
    const result = fetch(environment.apiUrlOne + '/token/create', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Cookies.get(environment.accessToken)
        }, body: JSON.stringify({"scope": "EMAIL_VERIFICATION"})
    })
    return await result;
}

export async function verifyEmail(tokenValue) {
    const result = fetch(environment.apiUrlOne + '/account/verifyEmail/' + tokenValue, {
        method: 'GET'
    })
    return await result;
}

export async function recoverPassword(tokenValue, password) {
    const result = fetch(environment.apiUrlOne + '/account/recoverPassword/' + tokenValue, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: password,
    })
    return await result;
}


export async function refreshAccessToken() {
    const result = fetch(environment.apiUrlTwo + '/auth/token', {
        method: 'POST',
        credentials: 'include'
    })
    return await result;
}

export async function logout(){
    const result = await fetch(environment.apiUrlTwo + '/auth/logout', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Authorization': Cookies.get(environment.accessToken)
        }
    })

    window.location.href = "/";
}
export async function logoutAll(){
    const result = await fetch(environment.apiUrlTwo + '/auth/logoutAllSessions', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Authorization': Cookies.get(environment.accessToken)
        }
    })

    window.location.href = "/";
}